import { getShouldReplace } from 'src/utils/getShouldReplace';
import { useModalContext } from '../useModalContext';
import { useTrackIncomingBonusTransaction as useTrackIncomingBonusTransactionOriginal } from 'react-easyrocket';
import { useBonusModalData } from 'src/modals/BonusModal/hooks/useBonusModalData';

/** Обертка над оригинальным хуком useTrackIncomingBonusTransaction для того
 * чтобы не мусорить в Router
 */
export const useTrackIncomingBonusTransaction = () => {
  const { openModal } = useModalContext();

  const getBonusInfo = useBonusModalData();

  useTrackIncomingBonusTransactionOriginal({
    openBonusModal: async (bonusTransaction) => {
      const bonusData = await getBonusInfo(bonusTransaction.id);      

      openModal('BONUS', {
        props: {
          bonusData
        },
        replace: getShouldReplace('BONUS')
      });
    },
    excludeJackpotWin: true
  });
};
